$w.onReady(function () {
    $w('#button14').onClick(() => {
        toggleBox($w('#newYorkCollapsibleBox'), $w('#image50'), $w('#image49'));
    });

    $w('#tokyoCollapseButton').onClick(() => {
        toggleBox($w('#tokyoCollapsibleBox'), $w('#tokyoPlusSign'), $w('#tokyoMinusSign'));
    });

    $w('#parisCollapseButton').onClick(() => {
        toggleBox($w('#parisCollapsibleBox'), $w('#parisPlusSign'), $w('#parisMinusSign'));
    });

    $w('#button8').onClick(() => {
        toggleBox($w('#box38'), $w('#image38'), $w('#image37'));
    });

    $w('#button9').onClick(() => {
        toggleBox($w('#box43'), $w('#image40'), $w('#image39'));
    });

    $w('#button10').onClick(() => {
        toggleBox($w('#box47'), $w('#image42'), $w('#image41'));
    });

    $w('#button11').onClick(() => {
        toggleBox($w('#box49'), $w('#image44'), $w('#image43'));
    });

    $w('#button12').onClick(() => {
        toggleBox($w('#box54'), $w('#image46'), $w('#image45'));
    });

    $w('#button13').onClick(() => {
        toggleBox($w('#box58'), $w('#image48'), $w('#image47'));
    });
});

function toggleBox(boxElement, plusSign, minusSign) {
    const isCollapsed = boxElement.collapsed;
    if (isCollapsed) {
        plusSign.hide();
        minusSign.show();
        boxElement.expand();
    } else {
        minusSign.hide();
        plusSign.show();
        boxElement.collapse();
    }
}